// translations.js - Основные переводы приложения

import ru from './ru.json';
import en from './en.json';

export default {
  app: {
    ru: ru,
    en: en
  }
};